import React from 'react';
import { BrowserRouter as Router, Routes, Route,Link,  NavLink } from 'react-router-dom';
import Chat from './Chat';
import Logo from './images/logo.png';
// import MCQGenerator from './MCQGenerator';
import StudentChat from './StudentChat';
import VoiceChat  from './components/chat/VoiceChat';
import MentiLipSyncTest from './MentiLipSyncTest';
import MentiRiveTest from './MentiRiveTest';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <img src={Logo} alt="Mentiora AI logo" width="200"/>
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link" }
                  to="/student-chat"
                  >New Chat</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                      className={({ isActive }) =>
                          isActive ? "nav-link active" : "nav-link"
                      }
                      to="/tutor-chat"
                  >Tutor Chat</NavLink>
                </li>

                {/* <li className="nav-item">
                  <Link className="nav-link" to="/mcq-generator">MCQ Generator</Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/menti-lipsync-test">MentiLipSync</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/student-chat" element={<StudentChat />} />
          <Route path="/tutor-chat" element={<Chat />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/" element={<StudentChat />} />
          <Route path="/voicechat" element={<VoiceChat />} />
          <Route path="/menti-lipsync-test" element={<MentiLipSyncTest />} />
          <Route path="/menti-lipsync-test2" element={<MentiRiveTest />} />
          {/* <Route path="/mcq-generator" element={<MCQGenerator />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
